import { Case } from '@src/domain/pages/support/cases/cases-dashboard/types/case.type';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import { ServiceNowCase } from 'cmp-client-api';

const transformToApiModel = (supportCase: ServiceNowCase): Case => ({
  ...supportCase,
  type: supportCase.type ?? 'Case',
  createdOn: new Date(supportCase.createdOn),
  updatedOn: new Date(supportCase.updatedOn),
});

export const CaseMapper: MapperInterface<ServiceNowCase, Case> = {
  transformToApiModel,
};
